
export function scMdFunc(funcName,json){
    sensors.track(funcName,json);
}
